import "./MenuButton.css";

export function MenuButton({ setOpen, open }) {
	return (
		<button
			type="button"
			className={`menuButton ${open ? "is-open" : ""}`}
			onClick={() => setOpen(!open)}
			aria-label={open ? "Close menu" : "Open menu"}
			aria-expanded={open}
		>
			<span className="menuButton_bar" />
			<span className="menuButton_bar" />
			<span className="menuButton_bar" />
		</button>
	);
}
